'use strict';

var core = require('integrations/productDetail');

var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
var toggleObject = siteIntegrations.getIntegrationSettings();
var productExtensions = [];

if (toggleObject.sfcommercepaymentsCartridgeEnabled) {
    productExtensions.push({
        payments: require('./integrations/commercepayments/product/payments')
    });
}

productExtensions.forEach(function (library) {
    Object.keys(library).forEach(function (item) {
        if (typeof library[item] === 'object') {
            core.baseFiles[item] = $.extend({}, core.baseFiles[item], library[item]);
        } else {
            core.baseFiles[item] = library[item];
        }
    });
});

module.exports = core;
